import { IndexedDBDatabase } from '../indexeddb.database';

export class HubStoreDatabase extends IndexedDBDatabase {

    public constructor() {
        super('HubStore', {
            reducers: ['name', 'state'],
        });
    }

}
